import { Planning } from 'src/app/classes/planning.class';
import { User } from 'src/app/classes/user.class';
import { AuthorisationService } from 'src/app/services/auth/authorisation.service';
import { Functionalities } from 'src/app/services/auth/functionalities';
import { EntityTypeCode } from 'src/app/services/entities/entity-type.class';
import { environment } from 'src/environments/environment';

const PlanningStatus = environment.status.Planning;

export class PlanningDetailViewModel {
    asphalt_location = false;
    traffic_controllers = true;
    traffic = true;
    mobile_crane = true;
    pouring_off = true;
    asphaltOthers = true;

    scatter = true;
    sticky_wagons = true;
    hire_people = true;
    set = true;
    asphalt_performer = true;
    dumpers = true;
    cranes = true;
    rollers = true;
    asfaltteam = true;
    preparationteam = true;
    projectteam = true;
    cutter = true;
    wipetruck = true;
    driver_user_id = false;

    contractor = true;
    performer = true;
    projectmanager = true;
    projectmanagerNotOwn = true;
    location = true;
    worknumber = true;

    cutterList = true;
    wipertruckList = true;

    asphaltFormDisabled = true;
    formDisabled = true;
    statusDisabled = false;
    fixedStatusDisabled = false;
    entitiesDisabled = false;
    employeeDisabled = false;

    showUserPlanning = false;

    sleepOrBlock = false;

    updateViewState(entityTypeCode: string, user: User, planning: Planning, fixed = true) {
        const entityTypeAsfaltTeam = entityTypeCode === EntityTypeCode.AsfaltTeam;
        const entityTypeProjectTeam = entityTypeCode === EntityTypeCode.ProjectTeam;
        const entityTypePreparationTeam = entityTypeCode === EntityTypeCode.PreparationTeam;
        const entityTypeWipetruck = entityTypeCode === EntityTypeCode.Wipetruck;
        const entityTypeCutter = entityTypeCode === EntityTypeCode.Cutter;

        this.showUserPlanning = [
            PlanningStatus.PlanningDefinitief,
            PlanningStatus.PlanningGepland,
            PlanningStatus.PlanningSlaapdag,
        ].includes(planning.status_key);
        this.sleepOrBlock = [PlanningStatus.PlanningSlaapdag, PlanningStatus.PlanningGeblokkeerd].includes(
            planning.status_key
        );
        const anyTeam = entityTypeAsfaltTeam || entityTypeProjectTeam || entityTypeProjectTeam;

        this.set = entityTypeAsfaltTeam && !this.sleepOrBlock;
        this.asfaltteam = entityTypeAsfaltTeam && !this.sleepOrBlock;
        this.projectteam = entityTypeProjectTeam && !this.sleepOrBlock;
        this.preparationteam = entityTypePreparationTeam && !this.sleepOrBlock;
        this.sticky_wagons = entityTypeAsfaltTeam && !this.sleepOrBlock;
        this.hire_people = anyTeam && !this.sleepOrBlock;
        this.pouring_off = entityTypeAsfaltTeam && !this.sleepOrBlock;
        this.asphaltOthers = entityTypeAsfaltTeam && !this.sleepOrBlock;
        this.asphalt_location = entityTypeAsfaltTeam && !this.sleepOrBlock;
        this.scatter = entityTypeAsfaltTeam && !this.sleepOrBlock;
        this.cutter = entityTypeCutter && !this.sleepOrBlock;
        this.wipertruckList = (entityTypeCutter || anyTeam) && !this.sleepOrBlock;
        this.cutterList = (entityTypeAsfaltTeam || entityTypePreparationTeam) && !this.sleepOrBlock;
        this.wipetruck = entityTypeWipetruck && !this.sleepOrBlock;
        this.driver_user_id =
            (entityTypeCutter || entityTypeWipetruck) &&
            !this.sleepOrBlock &&
            AuthorisationService.hasFunctionality(Functionalities.PlanningOverviewManagement);
        this.asphalt_performer = entityTypeAsfaltTeam && !this.sleepOrBlock;
        this.dumpers = anyTeam && !this.sleepOrBlock;
        this.cranes = anyTeam && !this.sleepOrBlock;
        this.rollers = anyTeam && !this.sleepOrBlock;
        this.traffic_controllers = !this.sleepOrBlock;
        this.traffic = !this.sleepOrBlock;
        this.contractor = planning.status_key !== PlanningStatus.PlanningGeblokkeerd;
        this.performer = !this.sleepOrBlock;
        this.projectmanager = !this.sleepOrBlock;
        this.projectmanagerNotOwn = AuthorisationService.hasFunctionality(Functionalities.PlanningOverviewManagement);
        this.location = !this.sleepOrBlock;
        this.worknumber = planning.status_key !== PlanningStatus.PlanningGeblokkeerd;

        this.formDisabled =
            user.id !== planning.projectmanager &&
            !AuthorisationService.hasAnyFunctionality([
                Functionalities.AsphaltManagement,
                Functionalities.PlanningOverviewManagement,
            ]);
        this.entitiesDisabled =
            (user.id !== planning.projectmanager || fixed) &&
            !AuthorisationService.hasAnyFunctionality([Functionalities.PlanningOverviewManagement]);
        this.statusDisabled =
            fixed && !AuthorisationService.hasFunctionality(Functionalities.PlanningOverviewManagement);
        this.asphaltFormDisabled =
            user.id !== planning.projectmanager &&
            !AuthorisationService.hasAnyFunctionality([
                Functionalities.AsphaltManagement,
                Functionalities.PlanningOverviewManagement,
            ]);
        this.employeeDisabled =
            (user.id !== planning.projectmanager || fixed) &&
            !AuthorisationService.hasAnyFunctionality([
                Functionalities.AsphaltManagement,
                Functionalities.PlanningOverviewManagement,
            ]);
        this.fixedStatusDisabled = fixed;
    }
}
